<template>
  <div>
    <!-- SAMPLE REQUESTS BELONGING TO THE LAB ADMIN -->
    <user-sample-requests></user-sample-requests>

    <!-- PUBLICATIONS BELONGING TO THE LAB ADMIN-->
    <user-publications></user-publications>
  </div>
</template>

<script>
import UserPublications from "@/components/dashboard/UserPublications";
import UserSampleRequests from "@/components/dashboard/UserSampleRequests";

export default {
name: "StudentDashboard",
  components: {UserPublications, UserSampleRequests}
}
</script>
